module.exports = __webpack_public_path__ + "media/ring.65ef578f.mp3";